import { useAuth } from '../../context/AuthContext'
import SalespersonDetailPage from '../admin/SalespersonDetailPage'

function MySalespersonPage() {
  const { user } = useAuth()

  if (!user?.salespersonId) {
    return (
        <div className="flex items-center justify-center h-64">
          <p className="text-slate-500">영업사원 정보를 불러올 수 없습니다.</p>
        </div>
    )
  }

  return (
      <SalespersonDetailPage
          salespersonId={user.salespersonId}
          readOnly={true}
      />
  )
}

export default MySalespersonPage
